export function getPinSVGData(color) {
    return `<svg xmlns="http://www.w3.org/2000/svg" width="25" height="36">
            <path
                id="path"
                d="M 12.354 1 C 5.898 1 0.667 6.073 0.667 12.335 C 0.667 17.513 3.487 23.077 6.259 27.388 C 9.032 31.7 11.806 34.76 11.806 34.76 C 12.073 35.054 12.535 35.081 12.837 34.823 C 12.86 34.804 12.882 34.783 12.902 34.76 C 12.902 34.76 15.677 31.636 18.449 27.3 C 21.221 22.964 24.042 17.412 24.042 12.335 C 24.042 6.073 18.811 1 12.354 1 Z"
                fill="${color}"
                stroke="#FFF"
                stroke-width="1"
            />
            <path
                id="path_1"
                d="M 12.354 8.084 C 9.539 8.084 7.241 10.313 7.241 13.043 C 7.241 15.773 9.539 18.002 12.354 18.002 C 15.17 18.002 17.468 15.773 17.468 13.043 C 17.468 10.313 15.17 8.084 12.354 8.084 Z"
                fill="#FFF"
                stroke="#FFF"
                stroke-width="1"
            />
            </svg>
            `;
}
